import { apiClient } from '@/lib/api';
export const billingApi = {
    /** Current subscription state for the authenticated org. */
    getSubscription: () => apiClient.get('/sslwidewatch/billing/subscription'),
    /**
     * Start a checkout for the given LS variant id. Returns a hosted LS URL
     * the portal should redirect the browser to.
     */
    createCheckout: (variantId, successRedirect) => apiClient.post('/sslwidewatch/billing/checkout', {
        variantId,
        successRedirect: successRedirect ?? window.location.origin + '/billing?upgraded=1',
    }),
    /** Returns the LS-hosted customer portal URL for self-serve management. */
    getPortalUrl: () => apiClient.post('/sslwidewatch/billing/portal-url', {}),
};
